import { Link } from "react-router-dom";
import { Settings2 } from "lucide-react";

const LINKS = [
  { to: "/privacy",             label: "Privacy Policy" },
  { to: "/cookies",             label: "Cookie Policy" },
  { to: "/terms",               label: "Terms & Conditions" },
  { to: "/affiliate-disclosure",label: "Affiliate Disclosure" },
  { to: "/ai-disclaimer",       label: "AI Disclaimer" },
  { to: "/contact",             label: "Contact" },
];

// Re-open the cookie consent banner. Components listen to this custom
// event to clear the saved preference and show the banner again.
const openCookiePrefs = () => {
  window.dispatchEvent(new CustomEvent("sbi:open-cookie-prefs"));
};

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative z-10 border-t border-border bg-card/30"
  >
    <div className="max-w-5xl mx-auto px-5 py-8 flex flex-col items-center gap-5">
      <Link to="/" aria-label="Should I Buy It? — Home" className="block">
        <img
          src="/brand/logo.png"
          alt="Should I Buy It? — AI-powered buying advice"
          width="160"
          height="160"
          className="h-24 w-auto opacity-90"
          draggable="false"
        />
      </Link>

      <nav
        className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs"
        aria-label="Legal links"
      >
        {LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`footer-link-${l.to.slice(1)}`}
            className="text-muted-foreground hover:text-foreground transition"
          >
            {l.label}
          </Link>
        ))}
        <button
          onClick={openCookiePrefs}
          data-testid="footer-cookie-prefs"
          className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground transition"
        >
          <Settings2 className="w-3 h-3" /> Cookie preferences
        </button>
      </nav>

      <div className="text-center text-[11px] text-muted-foreground/80 leading-relaxed max-w-2xl">
        ShouldIBuyIt.co.uk · Helping people spend their money more wisely.
        <br />
        As an Amazon Associate we earn from qualifying purchases. Recommendations are
        generated by AI and should be treated as guidance, not professional advice.
      </div>
    </div>
  </footer>
);

export default Footer;
